import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta';

const page = path => () => import(`@/views/pages${path}.vue`);

Vue.use(VueRouter)
Vue.use(Meta);

const routes = [
  {
    path: '/',
    component: page('/Home')
  },
  {
    path: 'ceo',
    redirect: 'ceo/2026/kim'
  },
  {
    path: 'ceo/2022',
    redirect: 'ceo/2022/kim'
  },
  {
    path: 'ceo/2023',
    redirect: 'ceo/2023/kim'
  },
  {
    path: 'ceo/2024',
    redirect: 'ceo/2024/kim'
  },
  {
    path: 'ceo/2025',
    redirect: 'ceo/2025/kim'
  },
  {
    path: 'ceo/2026',
    redirect: 'ceo/2026/kim'
  },
  {
    path: 'ceo/2022/:ceo(chang|kim)',
    component: page('/Ceo2022')
  },
  {
    path: 'ceo/2023/:ceo(chang|kim)',
    component: page('/Ceo2023')
  },
  {
    path: 'ceo/2024/:ceo(chang|kim)',
    component: page('/Ceo2024')
  },
  {
    path: 'ceo/2025/:ceo(kim)',
    component: page('/Ceo2025')
  },
  {
    path: 'ceo/2026/:ceo(kim)',
    component: page('/Ceo2026')
  },
  {
    path: 'our-mission',
    component: page('/OurMission')
  },
  {
    path: 'our-history',
    component: page('/OurHistory')
  },
  {
    path: 'main',
    component: page('/Main')
  },
  {
    path: 'reports',
    redirect: 'reports/annual'
  },
  {
    path: 'reports/:reports(annual|audit|ir)',
    component: page('/Reports')
  },
  {
    path: 'news',
    component: page('/News')
  },
  {
    path: 'news/detail/:sq',
    name: 'NewsDetail',
    component: page('/NewsDetail')
  },
  {
    path: 'space',
    redirect: 'space/intro'
  },
  {
    path: 'space/:space(intro|his|cis)',
    component: page('/Space')
  },
  {
    path: 'link',
    component: page('/Link')
  }
]

export default () => new VueRouter({
  mode: 'history',
  scrollBehavior: () => null,
  base: process.env.BASE_URL,
  routes: [
    { path: '/', redirect: '/ko/' },
    {
      path: '/:lang(en|ko)',
      component: page('/language-root'),
      children: routes
    }
  ]
})
